import { useEffect, useMemo } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { MentionEntityTypeEnum } from '@/types/schema';

interface Params<T> {
  items: T[];
  initialItems?: T[];
  fetching: boolean;
  defaultView?: MentionEntityTypeEnum;
}

const usePopperListItems = <T>(params: Params<T>): T[] => {
  const { initialItems, items, fetching, defaultView } = params;
  const [showInitialItems, { off }] = useToggle(fetching && !defaultView);

  useEffect(() => {
    if (fetching) {
      return;
    }

    if (showInitialItems) {
      off();
    }
  }, [fetching, off, showInitialItems]);

  return useMemo(
    () => (showInitialItems ? initialItems || [] : items),
    [items, initialItems, showInitialItems],
  );
};

export default usePopperListItems;
